import L from "leaflet";

const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export function createBasemapLayer(style: "light" | "dark"): L.TileLayer {
  const key = import.meta.env.VITE_CARTO_BASEMAPS_API_KEY?.trim();

  // CARTO returns watermarked tiles without a key, rather than a tile error.
  if (key) {
    return L.tileLayer(
      `https://{s}.basemaps.cartocdn.com/${style}_all/{z}/{x}/{y}{r}.png?key=${encodeURIComponent(key)}`,
      {
        attribution: `${OSM_ATTRIBUTION} &copy; <a href="https://carto.com/attributions">CARTO</a>`,
        maxZoom: 19,
        referrerPolicy: "strict-origin-when-cross-origin",
      },
    );
  }

  return L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: OSM_ATTRIBUTION,
    maxZoom: 19,
    referrerPolicy: "strict-origin-when-cross-origin",
    className: style === "dark" ? "wind-map-dark-basemap" : "",
  });
}
